import { c as _c } from "react/compiler-runtime";
import type { CalendarDate } from '@internationalized/date';
import { isSameMonth, isToday } from '@internationalized/date';
import { useCalendarCell } from '@react-aria/calendar';
import { useFocusRing } from '@react-aria/focus';
import { mergeProps } from '@react-aria/utils';
import type { CalendarState, RangeCalendarState } from '@react-stately/calendar';
import type { RefObject } from 'react';
import { DEFAULT_TIME_ZONE } from '@/lib/time-zone';
export type UseCellProps = {
  state: CalendarState | RangeCalendarState;
  date: CalendarDate;
  currentMonth: CalendarDate;
};
export const useCell = (t0, ref) => {
  const $ = _c(14);
  const {
    state,
    date,
    currentMonth
  } = t0;
  let t1;
  if ($[0] !== date) {
    t1 = {
      date
    };
    $[0] = date;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const cell = useCalendarCell(t1, state, ref);
  const {
    focusProps,
    isFocusVisible
  } = useFocusRing();
  let t2;
  if ($[2] !== cell.buttonProps || $[3] !== focusProps) {
    t2 = mergeProps(cell.buttonProps, focusProps);
    $[2] = cell.buttonProps;
    $[3] = focusProps;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const mergedButtonProps = t2;
  const isDisabledOrUnavailable = cell.isDisabled || cell.isUnavailable;
  let t3;
  if ($[5] !== date) {
    t3 = isToday(date, DEFAULT_TIME_ZONE);
    $[5] = date;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const isTodayCell = t3;
  const isOutsideMonth = !isSameMonth(currentMonth, date);
  let t4;
  if ($[7] !== cell || $[8] !== isDisabledOrUnavailable || $[9] !== isFocusVisible || $[10] !== isOutsideMonth || $[11] !== isTodayCell || $[12] !== mergedButtonProps) {
    t4 = {
      cell,
      isFocusVisible,
      isDisabledOrUnavailable,
      isTodayCell,
      isOutsideMonth,
      mergedButtonProps,
      cellProps: cell.cellProps
    };
    $[7] = cell;
    $[8] = isDisabledOrUnavailable;
    $[9] = isFocusVisible;
    $[10] = isOutsideMonth;
    $[11] = isTodayCell;
    $[12] = mergedButtonProps;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};